module.exports = __webpack_public_path__ + "static/media/icon05.df46f39e.png";